import classNames from "classnames";
import { useEffect, useState } from "react";
import ChooseIntent from "./ChooseIntent";
import ChooseLink from "./ChooseLink";
import EditIntent from "./EditIntent";
import EditTargetArea from "./EditTargetArea";

const App = () => {

	const [isOpen, setIsOpen] = useState(false);
	const [triggers, setTriggers] = useState(null);
	const [targetArea, setTargetArea] = useState(null);
	const [intent, setIntent] = useState(null);
	const [intents, setIntents] = useState([]);
	const [links, setLinks] = useState([]);

	useEffect(() => {

		// store the trigger buttons in state
		setTriggers(document.querySelectorAll('.js-service-modal-trigger'));

		// set the intial target area
		setTargetArea(SERVICES[0]);
	}, []);

	useEffect(() => {
		addClickEventsToTriggers();
	}, [triggers]);

	useEffect(() => {

		// reset the intent and links
		reset();

		// if we have a target area, update the intents
		if (targetArea) {
			updateIntentsForTargetArea(targetArea);
		}

	}, [targetArea]);

	useEffect(() => {

		// if we have an intent, update the links
		if (intent) {
			updateLinksForIntent(intent);
		}

	}, [intent]);

	/**
	 * Updates the intents for the given area
	 * @param {object} newArea an object representing the area to extract intents from
	 */
	const updateIntentsForTargetArea = newArea => {
		setIntents(newArea.children);
	}

	/**
	 * Updates the links for the given intent
	 * @param {object} newIntent an object representing the intent to extract links from
	 */
	const updateLinksForIntent = newIntent => {
		setLinks(newIntent.children);
	}

	/**
	 * Adds a click event to each trigger, which will update the current target area
	 * based on the slug defined in the data-target-area attribute of the trigger
	 * @returns void
	 */
	const addClickEventsToTriggers = () => {
		if (!triggers) {
			return false;
		}

		triggers.forEach(trigger => {
			trigger.addEventListener('click', e => {
				e.preventDefault();
				let slug = e.currentTarget.dataset.targetArea;
				let area = SERVICES.find(s => s.slug === slug);
				setTargetArea(area);
				setIsOpen(true);
			});
		});
	}

	/**
	 * Update the target area in state when the select is changed
	 * @param {Event} e the event object
	 */
	const handleTargetAreaSelectChange = e => {
		const selectedArea = SERVICES.find(s => s.slug === e.currentTarget.value);
		setTargetArea(selectedArea);
	}

	/**
	 * Update the intent in state when the select is changed
	 * @param {Event} e the event object
	 */
	const handleIntentsSelectChange = e => {
		const selectedIntent = intents.find(i => i.slug === e.currentTarget.value);
		setIntent(selectedIntent);
	}

	/**
	 * Resets the path back to the intent selection
	 */
	const reset = () => {
		setIntent(null);
		setLinks(null);
	}

	const classes = classNames(
		'services-modal',
		{ 'is-open': isOpen },
		{ 'services-modal--myself': targetArea?.name === 'Myself' },
		{ 'services-modal--my-business': targetArea?.name === 'My Business' },
		{ 'services-modal--my-local-area': targetArea?.name === 'My Local Area' },
		{ 'services-modal--intents': intent},
	);

	return (
		<div className={classes} onClick={() => setIsOpen(false)}>
			<div className="services-modal__inner" onClick={e => e.stopPropagation()}>

				<div className="services-modal__close">
					<button onClick={() => setIsOpen(false)} className="services-modal__close-button">
						<span>&times;</span>			
					</button>
				</div>

				<div className="services-modal__step-count">
					{intent ? '2' : '1'} / 2
				</div>

				<div className="services-modal__steps">

				<EditTargetArea
					serviceAreas={SERVICES}
					handleTargetAreaSelectChange={handleTargetAreaSelectChange}
					targetArea={targetArea}
				/>
				
				<ChooseIntent
					intents={intents}
					intent={intent}
					setIntent={setIntent}
				/>

				<EditIntent
					intents={intents}
					intent={intent}
					handleIntentsSelectChange={handleIntentsSelectChange}
				/>

				<ChooseLink
					links={links}
					reset={reset}
				/>

				</div>

			</div>
		</div>
	);
}
 
export default App;